<template>
    <div class="row">
        <div class="col-lg-4">
            <div class="form-group mb-4">
                <label>
                    <strong>
                        Invoice Dates
                    </strong>
                </label>
                <div class="input-daterange input-group">
                    <input v-model="filters.invoiceDateFrom" class="input-sm form-control js-flatpickers" name="invoice_start" value="" type="date">
                    <span class="input-group-addon">to</span>
                    <input v-model="filters.invoiceDateTo" class="input-sm form-control js-flatpickers" name="invoice_end" value="" type="date">
                </div>
            </div>
            <div class="form-group mb-4">
                <label>
                    <strong>
                        Due Dates
                    </strong>
                </label>
                <div class="input-daterange input-group">
                    <input v-model="filters.dueDateFrom" class="input-sm form-control js-flatpickers" name="due_start" value="" type="date">
                    <span class="input-group-addon">to</span>
                    <input v-model="filters.dueDateTo" class="input-sm form-control js-flatpickers" name="due_end" value="" type="date">
                </div>
            </div>
        </div>
        <div class="col-lg-2">
            <div class="rounded-2 py-2 px-3 text-white" :class="`bg-${pendingSeverity}`">
                <p class="mb-0">Invoices pending to Xero</p>
                <p class="h2 mb-0">{{ pendingXeroInvoices }}</p>
            </div>
        </div>
        <div class="col-lg-3">
            <CustomerSelect
                v-if="!hide.includes('customer')"
                v-model="filters.selectedCustomer"
                :ajax-url="generateCustomerSelectRoute()"
            />
            <div class="form-group">
                <label>
                    <strong>
                        Versions To Include
                    </strong>
                </label>
                <div class="checkbox checkbox-circle checkbox-primary">
                    <label for="checkbox-versions-latest" class="" title="latest versions of all invoices">
                        <input v-model="filters.versionsToInclude" id="checkbox-versions-latest" class="me-1" type="radio" name="version" value="latest" />
                        Latest Versions Only
                    </label>
                </div>
                <div class="checkbox checkbox-circle checkbox-primary">
                    <label for="checkbox-versions-superceded" title="all versions of all invoices">
                        <input v-model="filters.versionsToInclude" id="checkbox-versions-superceded" class="me-1" type="radio" name="version" value="all" />
                        All Versions
                    </label>
                </div>
            </div>
        </div>

        <div class="col-lg-3">
            <div class="form-group mb-4">
                <label>
                    <strong>
                        Purchase Order
                    </strong>
                </label>
                <input v-model="filters.purchaseOrder" type="text" class="form-control" name="client_ref" placeholder="Enter a PO" />
            </div>
            <div class="row mb-4">
                <div class="col-lg-6">
                    <label>
                        <strong>
                            Export Status
                        </strong>
                    </label>
                    <div class="checkbox checkbox-circle checkbox-primary">
                        <label for="checkbox-sage-all" title="all invoices regardless of sage status">
                            <input v-model="filters.sageStatus" class="me-1" id="checkbox-sage-all" type="radio" name="sage" value="all" checked="checked" />
                            All
                        </label>
                    </div>
                    <div class="checkbox checkbox-circle checkbox-primary">
                        <label for="checkbox-sage-exported" title="invoices that have been exported to sage">
                            <input v-model="filters.sageStatus" class="me-1" id="checkbox-sage-exported" type="radio" name="sage" value="exported" />
                            Exported
                        </label>
                    </div>
                    <div class="checkbox checkbox-circle checkbox-primary">
                        <label for="checkbox-sage-not_exported" title="invoices that have yet to be export">
                            <input v-model="filters.sageStatus" id="checkbox-sage-not_exported" class="me-1" type="radio" name="sage" value="not_exported" />
                            Not Yet Exported
                        </label>
                    </div>
                </div>
                <div class="col-lg-6">
                    <label>
                        <strong>
                            Has been emailed
                        </strong>
                    </label>
                    <div class="checkbox checkbox-circle checkbox-primary">
                        <label for="checkbox-emailed-all" title="all invoices regardless of emailed status">
                            <input v-model="filters.hasBeenEmailed" id="checkbox-emailed-all" class="me-1" type="radio" name="emailed" value="all" checked="checked" />
                            All
                        </label>
                    </div>
                    <div class="checkbox checkbox-circle checkbox-primary">
                        <label for="checkbox-emailed-have_been" title="invoices that have been emailed">
                            <input v-model="filters.hasBeenEmailed" id="checkbox-emailed-have_been" class="me-1" type="radio" name="emailed" value="have_been" />
                            Emailed
                        </label>
                    </div>
                    <div class="checkbox checkbox-circle checkbox-primary">
                        <label for="checkbox-emailed-not" title="invoices that have yet to be emailed">
                            <input v-model="filters.hasBeenEmailed" id="checkbox-emailed-not" class="me-1" type="radio" name="emailed" value="not" />
                            Not Yet Emailed
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <table
        ref="tableElementRef"
        id="datatable-invoice-list"
        class="table table-bordered table-striped table-vcenter dataTable"
        style="width: 100%;"
    >
        <thead>
            <tr>
                <th v-if="!hide.includes('select')" class="text-center">
                    <input type="checkbox" id="checkAll" />
                </th>
                <th v-if="!hide.includes('reference')">Reference</th>
                <th v-if="!hide.includes('customer')">Customer</th>
                <th v-if="!hide.includes('purchase_order')">Purchase Order</th>
                <th v-if="!hide.includes('invoice_date')">Invoice Date</th>
                <th v-if="!hide.includes('due_date')">Due Date</th>
                <th v-if="!hide.includes('total')">Total</th>
                <th v-if="!hide.includes('exported_to_sage')">Exported to Sage</th>
                <th v-if="!hide.includes('emailed_to_customer')">Emailed to Customer</th>
                <th v-if="!hide.includes('actions')">Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>

    <div  class="d-flex flex-wrap mb-3">
        <div class="w-100">
            <p class="mb-2 mt-3">
                <strong>
                    Bulk Actions:
                </strong>
            </p>
            <p class="mb-2">
                If there are items selected using the checkboxes, these actions will be performed on the selected items only.
            </p>
            <p class="mb-2">
                If there are no items selected using the checkboxes, these actions will be performed on all items currently shown in the table (i.e. after filtering).
            </p>
        </div>
        <div class="d-flex align-items-center mb-2 w-100">
            <ul class="selectedList list-inline mb-2">
                <li v-if="selectedInvoiceVersions.length > 0" class="list-inline-item"><strong>Checked:</strong></li>
                <li v-for="invoice in selectedInvoiceVersions" :key="invoice.id" class="list-inline-item">
                    <span class="badge bg-primary">{{ invoice.reference || invoice.id }}</span>
                </li>
                <li v-if="selectedInvoiceVersions.length > 0" class="list-inline-item">
                    <a href="#" @click.prevent="selectedInvoiceVersions = []">Clear?</a>
                </li>
            </ul>
        </div>

        <form :action="generateExportToSageRoute()" method="POST" target="_blank">
            <input type="hidden" name="_token" :value="csrfToken">
            <input type="hidden" name="invoice_version_ids[]" v-for="invoice in selectedInvoiceVersions" :key="invoice.id" :value="invoice.id">
            <input type="hidden" name="invoice_date_from" :value="filters.invoiceDateFrom">
            <input type="hidden" name="invoice_date_to" :value="filters.invoiceDateTo">
            <input type="hidden" name="due_date_from" :value="filters.dueDateFrom">
            <input type="hidden" name="due_date_to" :value="filters.dueDateTo">
            <input type="hidden" name="versions_to_include" :value="filters.versionsToInclude">
            <input type="hidden" name="purchase_order" :value="filters.purchaseOrder">
            <input type="hidden" name="sage_status" :value="filters.sageStatus">
            <input type="hidden" name="has_been_emailed" :value="filters.hasBeenEmailed">
            <input type="hidden" name="selected_customer" :value="filters.selectedCustomer ? filters.selectedCustomer.id : ''">
            <button class="btn btn-success btn-sm me-2">
                <i class="fa fa-file-export me-1"></i> Export These To Xero
            </button>
        </form>

        <form :action="generateDownloadAsZipRoute()" method="POST" target="_blank">
            <input type="hidden" name="_token" :value="csrfToken">
            <input type="hidden" name="invoice_version_ids[]" v-for="invoice in selectedInvoiceVersions" :key="invoice.id" :value="invoice.id">
            <input type="hidden" name="invoice_date_from" :value="filters.invoiceDateFrom">
            <input type="hidden" name="invoice_date_to" :value="filters.invoiceDateTo">
            <input type="hidden" name="due_date_from" :value="filters.dueDateFrom">
            <input type="hidden" name="due_date_to" :value="filters.dueDateTo">
            <input type="hidden" name="versions_to_include" :value="filters.versionsToInclude">
            <input type="hidden" name="purchase_order" :value="filters.purchaseOrder">
            <input type="hidden" name="sage_status" :value="filters.sageStatus">
            <input type="hidden" name="has_been_emailed" :value="filters.hasBeenEmailed">
            <input type="hidden" name="selected_customer" :value="filters.selectedCustomer ? filters.selectedCustomer.id : ''">
            <button class="btn btn-primary btn-sm me-2">
                <i class="fa fa-file-archive me-1"></i> Download These In A Zip
            </button>
        </form>

        <form :action="generateDownloadAsZipRoute()" method="POST" target="_blank">
            <input type="hidden" name="_token" :value="csrfToken">
            <input type="hidden" name="invoice_version_ids[]" v-for="invoice in selectedInvoiceVersions" :key="invoice.id" :value="invoice.id">
            <input type="hidden" name="invoice_date_from" :value="filters.invoiceDateFrom">
            <input type="hidden" name="invoice_date_to" :value="filters.invoiceDateTo">
            <input type="hidden" name="due_date_from" :value="filters.dueDateFrom">
            <input type="hidden" name="due_date_to" :value="filters.dueDateTo">
            <input type="hidden" name="versions_to_include" :value="filters.versionsToInclude">
            <input type="hidden" name="purchase_order" :value="filters.purchaseOrder">
            <input type="hidden" name="sage_status" :value="filters.sageStatus">
            <input type="hidden" name="has_been_emailed" :value="filters.hasBeenEmailed">
            <input type="hidden" name="selected_customer" :value="filters.selectedCustomer ? filters.selectedCustomer.id : ''">
            <input type="hidden" name="one_long_pdf" value="1">
            <button class="btn btn-primary btn-sm me-2">
                <i class="fa fa-file-pdf me-1"></i> Download These As A Long PDF
            </button>
        </form>

        <form :action="generateBulkEmailRoute()" method="POST" target="_blank">
            <input type="hidden" name="_token" :value="csrfToken">
            <input type="hidden" name="invoice_version_ids[]" v-for="invoice in selectedInvoiceVersions" :key="invoice.id" :value="invoice.id">
            <button class="btn btn-danger btn-sm">
                <i class="fa fa-envelope me-1"></i> Email These
            </button>
        </form>
    </div>

</template>


<script setup>

    import { onBeforeUnmount, onMounted, reactive, ref, toRaw, watch } from 'vue';
    import axios from 'axios';
    import { buildColumns } from "@/helpers/build-columns";
    import CustomerSelect from "@/components/movements/components/CustomerSelect.vue";
    import { errorAlert, generateErrorResponse } from "@/utils";

    const props = defineProps({
        ajaxUrl: {
            type: String,
            required: true,
        },
        hide: {
            type: Array,
            default: () => [],
            required: false,
        },
        sortIndex: {
            type: [Number, null],
            default: null,
            required: false,
        },
    });

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    const tableElementRef = ref(null);
    const customersToInvoice = ref([]);
    const customersWithInvoice = ref([]);
    const pendingXeroInvoices = ref(0);
    const pendingSeverity = ref('navy');
    const selectedInvoiceVersions = ref([]);

    const filters = reactive({
        invoiceDateFrom: null,
        invoiceDateTo: null,
        dueDateTo: null,
        dueDateFrom: null,
        versionsToInclude: 'latest',
        purchaseOrder: null,
        sageStatus: 'all',
        hasBeenEmailed: 'all',
        selectedCustomer: null,
    });

    const columnDefinitions = {
        select: {
            data: 'id',
            orderable: false,
            searchable: false,
            width: '70px',
            render: function (data, type, row) {
                return row.computed_select;
            },
        },
        reference: {
            data: 'invoice_id',
            searchable: false,
            render: function (data, type, row) {
                return row.computed_reference;
            },
        },
        customer: {
            data: 'customer.id',
            orderable: false,
            searchable: false,
            render: function (data, type, row) {
                return row.computed_customer;
            },
        },
        purchaseOrder: {
            name: 'client_ref',
            searchable: false,
            orderable: false,
            render: function (data, type, row) {
                return row.computed_client_ref;
            },
        },
        invoiceDate: {
            data: 'invoice_date',
            name: 'invoice_date',
            searchable: false,
        },
        dueDate: {
            data: 'due_date',
            name: 'due_date',
            searchable: false,
        },
        total: {
            data: 'total_inc_vat',
            searchable: false,
            orderable: false,
            render: (data) => '£' + parseFloat(data).toLocaleString('en-GB', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }),
        },
        exportedToSage: {
            data: 'invoice.exported_to_sage',
            searchable: false,
            orderable: false,
            render: function (data) {
                switch (data) {
                    case 2:
                        return 'Blocked';
                    case 1:
                        return 'Yes';
                    case 0:
                        return 'No';
                    default:
                        return 'N/A';
                }
            },
        },
        emailedToCustomer: {
            data: 'last_emailed',
            searchable: false,
            orderable: false,
            render: function (data) {
                return (data !== null && data.length > 0) ? 'Yes' : 'No';
            },
        },
        actions: {
            name: 'actions',
            data: 'actions',
            searchable: false,
            orderable: false,
            width: '200px',
        },
    };


    const generateExportToSageRoute = () => route('movements.invoices.export-to-sage');
    const generateDownloadAsZipRoute = () => route('movements.invoices.download-zip');
    const generateBulkEmailRoute = () => route('movements.invoices.bulk-email');
    const generateCustomerSelectRoute = () => route('api.movements.invoices.list-customers');
    const generateInvoicesPendingToXeroRoute = () => route('api.movements.invoices.invoices-pending-to-xero');

    const getInvoiceSelectionFromCheckbox = (checkbox) => {
        if (!checkbox) {
            return null;
        }

        try {
            const parsedValue = JSON.parse(checkbox.value);
            const invoiceId = parsedValue?.id ?? null;

            if (invoiceId === null) {
                return null;
            }

            return {
                id: invoiceId,
                reference: parsedValue?.reference ?? null,
            };
        } catch (error) {
            errorAlert(
                generateErrorResponse({ invoiceSelection: ['Unable to parse invoice selection.'] }),
                'Invoice Selection Error'
            );
            return null;
        }
    };

    const isInvoiceSelected = (invoiceId) => selectedInvoiceVersions.value.some((invoice) => invoice.id === invoiceId);

    const setInvoiceSelection = (invoice, shouldSelect) => {
        const invoiceId = invoice?.id;

        if (invoiceId === null || invoiceId === undefined) {
            return;
        }

        if (shouldSelect) {
            if (!isInvoiceSelected(invoiceId)) {
                selectedInvoiceVersions.value = [
                    ...selectedInvoiceVersions.value,
                    {
                        id: invoiceId,
                        reference: invoice?.reference ?? null,
                    },
                ];
            }
            return;
        }

        if (isInvoiceSelected(invoiceId)) {
            selectedInvoiceVersions.value = selectedInvoiceVersions.value.filter((storedInvoice) => storedInvoice.id !== invoiceId);
        }
    };

    let tableElementJq = null;

    const getTableElement = () => {
        if (tableElementJq && tableElementJq.length) {
            return tableElementJq;
        }

        if (!tableElementRef.value) {
            return null;
        }

        tableElementJq = window.jQuery(tableElementRef.value);
        return tableElementJq;
    };

    const syncSelectAllCheckbox = () => {
        const tableElement = getTableElement();

        if (!tableElement || !tableElement.length) {
            return;
        }

        const selectAllElement = tableElement.find('#checkAll').get(0);

        if (!selectAllElement) {
            return;
        }

        const checkboxes = tableElement.find('.bulk-update-checkbox');
        const checkedCheckboxes = checkboxes.filter(':checked');
        const total = checkboxes.length;
        const checkedCount = checkedCheckboxes.length;

        selectAllElement.indeterminate = checkedCount > 0 && checkedCount < total;
        selectAllElement.checked = total > 0 && checkedCount === total;
    };

    const syncCheckboxesWithState = (checkboxes) => {
        checkboxes.each((_, element) => {
            const checkbox = element;
            const invoice = getInvoiceSelectionFromCheckbox(checkbox);
            const invoiceId = invoice?.id ?? null;
            checkbox.checked = invoiceId !== null && isInvoiceSelected(invoiceId);
        });

        syncSelectAllCheckbox();
    };

    const handleDraw = () => {
        const tableElement = getTableElement();
        if (!tableElement || !tableElement.length) {
            return;
        }

        const selectAll = tableElement.find('#checkAll');
        const checkboxes = tableElement.find('.bulk-update-checkbox');

        syncCheckboxesWithState(checkboxes);

        checkboxes.off('change.invoiceSelect');
        selectAll.off('change.invoiceSelect');

        checkboxes.on('change.invoiceSelect', (event) => {
            const checkbox = event.currentTarget;
            const invoice = getInvoiceSelectionFromCheckbox(checkbox);
            setInvoiceSelection(invoice, checkbox.checked);
            syncSelectAllCheckbox();
        });

        if (selectAll.length) {
            selectAll.on('change.invoiceSelect', (event) => {
                const selectAllCheckbox = event.currentTarget;
                const shouldSelectAll = selectAllCheckbox.checked;
                selectAllCheckbox.indeterminate = false;

                checkboxes.each((_, element) => {
                    const checkbox = element;
                    const invoice = getInvoiceSelectionFromCheckbox(checkbox);
                    checkbox.checked = shouldSelectAll;
                    setInvoiceSelection(invoice, shouldSelectAll);
                });

                syncSelectAllCheckbox();
            });
        }
    };

    let tableInstance = null;
    let stopWatchingFilters = null;

    onMounted(() => {
        const tableElement = getTableElement();

        if (!tableElement || !tableElement.length) {
            return;
        }

        tableElement.on('preXhr.dt', (e, settings, data) => {
            data.filters = { ...toRaw(filters) };
        });

        tableInstance = tableElement.DataTable({
            processing: true,
            serverSide: true,
            pageLength: 25,
            lengthMenu: [25, 50, 100],
            ajax: {
                url: props.ajaxUrl,
            },
            order: [[4, 'desc']],
            columns: buildColumns(columnDefinitions, props.hide),
        });

        stopWatchingFilters = watch(
            filters,
            () => {
                if (tableInstance) {
                    tableInstance.ajax.reload(null, false);
                }
            },
            { deep: true }
        );

        tableInstance.on('draw', handleDraw);

        axios.get(generateInvoicesPendingToXeroRoute())
            .then((response) => {
                customersToInvoice.value = response.data.customersToInvoice;
                customersWithInvoice.value = response.data.customersWithInvoice;
                pendingXeroInvoices.value = response.data.pendingXeroInvoices;
                pendingSeverity.value = response.data.pendingSeverity;
            })
            .catch((error) => {
                console.log(error);
            });
    });

    onBeforeUnmount(() => {
        if (stopWatchingFilters) {
            stopWatchingFilters();
            stopWatchingFilters = null;
        }

        if (tableInstance) {
            tableInstance.off('draw', handleDraw);
            tableInstance.destroy(true);
            tableInstance = null;
        }

        if (tableElementJq) {
            tableElementJq.off('preXhr.dt');
            tableElementJq = null;
        }
    });

    watch(selectedInvoiceVersions, () => {
        const tableElement = getTableElement();
        if (!tableElement || !tableElement.length) return;
        const checkboxes = tableElement.find('.bulk-update-checkbox');
        syncCheckboxesWithState(checkboxes);
    });
</script>
